
import * as React from 'react';
import { Split } from "stores/types";
import { nanoid } from 'nanoid';

type CreateSplitPropsType = {
    onSplit: (split: Split[]) => void;
}

const CreateSplit: React.FC<CreateSplitPropsType> = ({ onSplit }) => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [splits, setSplits] = React.useState<Split[]>([{ id: nanoid(), cashfreeVendorId: '', amount: '' }]);

    const onAdd = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        setSplits([...splits, { id: nanoid(), cashfreeVendorId: '', amount: '' }]);
    }

    const onDelete = (e: any, split: Split) => {
        e.preventDefault();
        e.stopPropagation();
        setSplits(splits.filter(s => s.id !== split.id));
    }

    const onChange = (split, target:string, value: string) => {
        setSplits(splits.map(s => {
            if(s.id === split.id) {
                return {
                    ...s,
                    [target]: value
                }
            }
            return s;
        }))
    }

    const onSubmit = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        await onSplit(splits);
        setLoading(false);
    }

    return (
        <div className="mt-4" >
            <form onSubmit={onSubmit} >
                <div className="grid gap-6 mb-6 md:grid-cols-3">
                    {
                        splits.map(split => (
                            <>
                                <div>
                                    <label htmlFor={`vendor_${split.id}`} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Cashfree vendor id</label>
                                    <input type="text" disabled={loading} id={`vendor_${split.id}`} onChange={e => onChange(split, "cashfreeVendorId", e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Cashfree vendor id" required />
                                </div>
                                <div>
                                    <label htmlFor={`amount_${split.id}`} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Amount</label>
                                    <input type="number" step=".0001" disabled={loading} id={`amount_${split.id}`} onChange={e => onChange(split, "amount", e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Amount" required />
                                </div>
                                <div>
                                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">&nbsp;</label>
                                    <button type="button" onClick={e => onDelete(e, split)} disabled={splits.length === 1 || loading} className="text-red-700 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 disabled:cursor-not-allowed">Remove</button>
                                </div>
                            </>
                        ))
                    }
                    <div>
                        <div className='flex flex-row items-center' >
                        <button type="button" disabled={loading} onClick={onAdd} className="text-blue-700 rounded-xl hover:text-white border border-purple-700 hover:bg-brand-800 focus:ring-4 focus:outline-none focus:ring-brand-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-brand-500 dark:text-brand-500 dark:hover:text-white dark:hover:bg-brand-500 dark:focus:ring-brand-800">Add Vendor</button>
                        <button type='submit' disabled={loading} className='text-white rounded-xl bg-brand-700 hover:bg-brand-800 focus:ring-4 focus:ring-brand-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-brand-600 dark:hover:bg-brand-700 focus:outline-none dark:focus:ring-brand-800 ml-4' >
                            Submit Split
                        </button>
                        </div>
                    </div>
                    <div />
                    <div />
                </div>
            </form>
        </div>
    )
}

export default CreateSplit;